import { Component, ElementRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { distinctUntilChanged } from 'rxjs';
import { changeDeviceView } from 'src/app/common/app.helpers';
import AppValues from 'src/app/common/app.values';
import { SearchService } from 'src/app/components/search/search.service';
import { FormFieldSate } from '../form-field.state';
import { SelectorOptionsService } from '../selector-options.service';
import { ItemValidationService } from './item-validation.service';
import { AdditionalCustomValidation } from './multiple-custom-form-field.enum';

@Component({
  selector: 'app-multiple-custom-form-field',
  templateUrl: './multiple-custom-form-field.component.html',
  styleUrls: ['./multiple-custom-form-field.component.scss'],
  providers: [SelectorOptionsService, SearchService, ItemValidationService],
})
export class MultipleCustomFormFieldComponent extends FormFieldSate implements OnInit {
  public selectedItems: string[] = [];
  public currentLength = 0;
  public maxLength = 10;
  public isMaxItems = false;
  public isMobileView = false;

  @ViewChild('multipleSearchInput', { static: false })
  public multipleSearchInput: ElementRef<HTMLInputElement>;

  private itemValidationService = inject(ItemValidationService);

  @HostListener('window:resize')
  public resizeWindow(): void {
    this.isMobileView = changeDeviceView(AppValues.DEFAULT_WIDTH_FOR_MOBILE);
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    this.initSelectedItems();
    this.subscribeToControlChanges();
    this.isMobileView = changeDeviceView(AppValues.DEFAULT_WIDTH_FOR_MOBILE);
  }

  public onCheckAndSelectItem(event: KeyboardEvent & { target: HTMLInputElement }): void {
    event.preventDefault();
    if (event.keyCode === 13) {
      this.changeSelectedList(event.target.value.trim());
    }
  }

  public onCloseItem(item: string): void {
    this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
    this.multipleSearchInput.nativeElement.focus();
    if (this.currentLength > 0) {
      this.currentLength -= 1;
    }

    this.changeSelectedList();
  }

  public onBlur(item: string): void {
    this.checkErrors();
    if (item.length > 0) {
      this.changeSelectedList(item.trim());
    }
  }

  public checkErrors(): void {
    this.formValidationService.checkMultipleSearchFieldValidationErrors(
      this.control,
      this.multipleSearchInput.nativeElement.value,
    );
  }

  public initSelectedItems(): void {
    this.selectedItems = (this.control.value as string[]) || [];
    this.currentLength = this.selectedItems.length;
    this.fillControlValue();
    this.subscribeToControlChanges();
  }

  public onValueChanged(): void {
    this.isMaxItems = this.currentLength === this.maxLength && Boolean(this.multipleSearchInput.nativeElement.value);
  }

  protected override onNullControlValue(): void {
    this.onControlDisabled();
    this.selectedItems = [];
    super.onNullControlValue();
  }

  private onControlDisabled(): void {
    if (this.multipleSearchInput) {
      this.multipleSearchInput.nativeElement.value = '';
    }
  }

  private fillControlValue(): void {
    this.control.setValue(this.selectedItems);
  }

  private changeSelectedList(newItem?: string): void {
    if (
      this.itemValidationService.itemValidationCheck(
        this.selectedItems,
        newItem,
        this.fieldAttribute.backendAttribute['additional_validation'] as AdditionalCustomValidation,
      )
    ) {
      this.selectedItems.push(newItem);
      this.currentLength += 1;
      this.multipleSearchInput.nativeElement.value = '';
      this.fillControlValue();
      return;
    }

    this.multipleSearchInput.nativeElement.value = '';
    this.fillControlValue();
    this.isMaxItems = false;
  }

  private subscribeToControlChanges(): void {
    this.subscriptions.push(
      this.control.statusChanges.pipe(distinctUntilChanged()).subscribe(() => {
        if (this.control.disabled) {
          this.onControlDisabled();
        }
      }),
    );
  }
}
